import { TableBaseCols } from '@ge/feat-reporting/components/widgets/table-widget/table-base-cols';

// All available columns and groups for completed work
export const ClosedCasesColumns = {
  GROUP_SELECTED: TableBaseCols.GROUP_SELECTED,
  SELECTED: TableBaseCols.SELECTED,

  GROUP_ASSET_DETAILS: 'Asset Details',
  ASSET_NAME: 'Asset Name',

  // Case Details
  GROUP_CASE_DETAILS: 'Case Details',
  CASE_PRIORITY: 'Priority',
  CASE_STATUS: 'Status',
  CASE_TITLE: 'Case Title',
  CASE_DESCRIPTION: 'Description',
  STATUS_DETAIL: 'Status Details',
  SOURCE: 'Source',

  // Dates
  GROUP_DATES: 'Dates',
  DATES_CREATED: 'Created',
  DATES_LAST_FLAGGED: 'Last Flagged',
  DATES_FIXED: 'Fixed',
  DATES_CLOSED: 'Closed',

  // Notes
  GROUP_NOTES: TableBaseCols.GROUP_NOTES,
  NOTES_LATEST_NOTE: TableBaseCols.NOTES_LATEST_NOTE,
  NOTES_EXTERNAL: TableBaseCols.NOTES_EXTERNAL,
  NOTES_INTERNAL: TableBaseCols.NOTES_INTERNAL,
};

// Completed work table configuration
export const closedCasesColumnDefs = {
  [ClosedCasesColumns.GROUP_SELECTED]: {
    fixedLeft: true,
    width: '50px',
    cols: {
      [ClosedCasesColumns.SELECTED]: {
        fixedLeft: true,
        locked: true,
        labels: [
          {
            a11yKey: 'cases.columns.include',
            a11yDefault: 'Include',
          },
        ],
        cell: {
          align: 'center',
          width: '50px',
        },
      },
    },
  },
  [ClosedCasesColumns.GROUP_ASSET_DETAILS]: {
    fixedLeft: true,
    width: '50px',
    labels: [
      {
        a11yKey: 'cases.columns.asset_details',
        a11yDefault: 'Asset Details',
      },
    ],
    cols: {
      [ClosedCasesColumns.ASSET_NAME]: {
        locked: true,
        fixedLeft: true,
        cell: {
          width: '100px',
        },
        labels: [
          {
            a11yKey: 'cases.columns.asset_name',
            a11yDefault: 'Asset Name',
          },
        ],
      },
    },
  },
  [ClosedCasesColumns.GROUP_CASE_DETAILS]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'cases.columns.case_details',
        a11yDefault: 'Case Details',
      },
    ],
    cols: {
      [ClosedCasesColumns.CASE_PRIORITY]: {
        cell: {
          width: '100px',
        },
        labels: [
          {
            a11yKey: 'cases.columns.priority',
            a11yDefault: 'Priority',
          },
        ],
      },
      [ClosedCasesColumns.CASE_TITLE]: {
        labels: [
          {
            a11yKey: 'cases.columns.case_title',
            a11yDefault: 'Case Title',
          },
        ],
      },
      [ClosedCasesColumns.SOURCE]: {
        labels: [
          {
            a11yKey: 'cases.columns.source',
            a11yDefault: 'Source',
          },
        ],
      },
      [ClosedCasesColumns.CASE_STATUS]: {
        labels: [
          {
            a11yKey: 'cases.columns.status',
            a11yDefault: 'Status',
          },
        ],
      },
      [ClosedCasesColumns.STATUS_DETAIL]: {
        labels: [
          {
            a11yKey: 'cases.columns.status_details',
            a11yDefault: 'Status Details',
          },
        ],
      },
      [ClosedCasesColumns.CASE_DESCRIPTION]: {
        cell: {
          width: '200px',
          maxWidth: '200px',
        },
        labels: [
          {
            a11yKey: 'cases.columns.case_description',
            a11yDefault: 'Description',
          },
        ],
      },
    },
  },
  [ClosedCasesColumns.GROUP_DATES]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'cases.columns.dates',
        a11yDefault: 'Dates',
      },
    ],
    cols: {
      [ClosedCasesColumns.DATES_CREATED]: {
        labels: [
          {
            a11yKey: 'cases.columns.created',
            a11yDefault: 'Created',
          },
        ],
      },
      [ClosedCasesColumns.DATES_LAST_FLAGGED]: {
        labels: [
          {
            a11yKey: 'cases.columns.last_flagged',
            a11yDefault: 'Last Flagged',
          },
        ],
      },
      [ClosedCasesColumns.DATES_FIXED]: {
        labels: [
          {
            a11yKey: 'cases.columns.fixed',
            a11yDefault: 'Fixed',
          },
        ],
      },
      [ClosedCasesColumns.DATES_CLOSED]: {
        labels: [
          {
            a11yKey: 'cases.columns.closed',
            a11yDefault: 'Closed',
          },
        ],
      },
    },
  },

  [ClosedCasesColumns.GROUP_NOTES]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'cases.columns.notes',
        a11yDefault: 'Notes',
      },
    ],
    cols: {
      [ClosedCasesColumns.NOTES_LATEST_NOTE]: {
        labels: [
          {
            a11yKey: 'cases.columns.latest_note',
            a11yDefault: 'Latest Note',
          },
        ],
      },
    },
  },
};

// Explicitly define columns that should not be shown in any user-selection
// scenarios (i.e. - report widget configuration).
export const closedCasesOmittedCols = [
  ClosedCasesColumns.GROUP_SELECTED,
  ClosedCasesColumns.SELECTED,
  // OpenCasesColumns.CASE_STATUS,
];

export const closedCasesCustomColConfigs = [ClosedCasesColumns.NOTES_LATEST_NOTE];

// Default order and visibility configuration for completed work columns
// NOTE: For state selection, EVERY column must have a position and visibility default!
export const closedCasesDefaultCols = [
  {
    id: ClosedCasesColumns.GROUP_SELECTED,
    cols: [
      {
        id: ClosedCasesColumns.SELECTED,
        visible: true,
        excludeFromCount: true,
      },
    ],
  },
  {
    id: ClosedCasesColumns.GROUP_ASSET_DETAILS,
    cols: [
      {
        id: ClosedCasesColumns.ASSET_NAME,
        visible: true,
        excludeFromCount: true,
      },
    ],
  },
  {
    id: ClosedCasesColumns.GROUP_CASE_DETAILS,
    cols: [
      {
        id: ClosedCasesColumns.CASE_TITLE,
        visible: false,
      },
      {
        id: ClosedCasesColumns.ASSET_NAME,
        visible: true,
      },
      {
        id: ClosedCasesColumns.CASE_PRIORITY,
        visible: true,
      },
      {
        id: ClosedCasesColumns.SOURCE,
        visible: true,
      },
      {
        id: ClosedCasesColumns.CASE_STATUS,
        visible: true,
      },
      {
        id: ClosedCasesColumns.STATUS_DETAIL,
        visible: false,
      },
      {
        id: ClosedCasesColumns.CASE_DESCRIPTION,
        visible: true,
      },
    ],
  },
  {
    id: ClosedCasesColumns.GROUP_DATES,
    ignoreTemplateConfig: true,
    cols: [
      {
        id: ClosedCasesColumns.DATES_CREATED,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: ClosedCasesColumns.DATES_LAST_FLAGGED,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: ClosedCasesColumns.DATES_FIXED,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: ClosedCasesColumns.DATES_CLOSED,
        visible: true,
      },
    ],
  },
  {
    id: ClosedCasesColumns.GROUP_NOTES,
    ignoreTemplateConfig: true,
    cols: [
      {
        id: ClosedCasesColumns.NOTES_LATEST_NOTE,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: ClosedCasesColumns.NOTES_INTERNAL,
        visible: false,
        excludeFromCount: true,
        ignoreTemplateConfig: true,
      },
      {
        id: ClosedCasesColumns.NOTES_EXTERNAL,
        visible: false,
        excludeFromCount: true,
        ignoreTemplateConfig: true,
      },
    ],
  },
];
